import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-lifecycle-stage-key'
const api = async (method, path, params) => axios[method](path, params)
function isValidPayload(payload) {
    if (!payload || !payload.name) {
        return false
    }
    return true
}

const state = {
    item: {},
    items: [],
}

const mutations = {
    set_lifecycle_stage(state, payload) {
        state.item = payload
    },
    set_lifecycle_stages(state, payload) {
        state.items = payload
    },
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            if (!isValidPayload(payload)) throw new Error('Data Required')
            const results = await api('post', `lifecycle-stage`, payload)
            context.commit('set_lifecycle_stage', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            const results = await api('get', `lifecycle-stage/${id}`)
            context.commit('set_lifecycle_stage', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `lifecycle-stage`)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_lifecycle_stages', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateCustomerLifecyleStageOrder(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            await api('post', `lifecycle-stage/update/display/order/`, payload)
        } catch (err) {
            errorHandler(err)
        }
    },
    async update(context, payload) {
        new StorageCache(storageKey).reset()
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `lifecycle-stage/${payload.id}`,
                payload
            )
            context.commit('set_lifecycle_stage', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        new StorageCache(storageKey).reset()
        try {
            await api('delete', `lifecycle-stage/${id}`)
            context.commit('set_lifecycle_stages', null)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
